import { render, staticRenderFns } from "./SimularQuitacaoDialog.vue?vue&type=template&id=5dda1a58"
import script from "./SimularQuitacaoDialog.vue?vue&type=script&lang=js"
export * from "./SimularQuitacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports